'use client'

import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useExploreDreamTeams } from '../hooks/useFootball'
import { useT } from '../contexts/LocaleContext'
import DreamTeamPitch from '../components/football/DreamTeamPitch'
import { faChevronRight, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export default function DreamTeamExplorePage() {
  const navigate = useNavigate()
  const t = useT()
  const [input, setInput] = useState('')
  const [query, setQuery] = useState('')
  const [searchOpen, setSearchOpen] = useState(false)

  const { data, isLoading, error } = useExploreDreamTeams(query, 48)
  const teams = data?.teams || []

  useEffect(() => {
    const timer = setTimeout(() => setQuery(input.trim()), 350)
    return () => clearTimeout(timer)
  }, [input])

  useEffect(() => {
    if (!query || teams.length !== 1) return
    const looksLikeLink =
      /team=\d+/i.test(query) ||
      /dream_\d+_\d+/i.test(query) ||
      (/^\d+$/.test(query) && teams[0].id === Number(query))
    if (!looksLikeLink) return
    navigate(`/football/dream-teams/${teams[0].id}`, { replace: true })
  }, [query, teams, navigate])

  return (
    <div className="dream-explore-shell">
      <header className="dream-explore-top">
        <div className="flex items-center justify-between gap-2">
          <button
            type="button"
            onClick={() => navigate('/football')}
            className="dream-feed-icon-btn"
            aria-label={t('common.back')}
          >
            <FontAwesomeIcon icon={faChevronRight} />
          </button>
          <button
            type="button"
            onClick={() => setSearchOpen((v) => !v)}
            className="dream-feed-icon-btn"
            aria-label={t('dreamTeam.explore.ariaSearch')}
          >
            <FontAwesomeIcon icon={faMagnifyingGlass} />
          </button>
        </div>
        {searchOpen && (
          <input
            type="text"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            placeholder={t('dreamTeam.explore.searchPlaceholder')}
            autoFocus
            className="dream-feed-search mt-2"
            dir="auto"
          />
        )}
      </header>

      {error ? (
        <div className="flex-1 flex items-center justify-center text-red-300 text-sm">{t('common.error')}</div>
      ) : isLoading ? (
        <div className="flex-1 flex items-center justify-center text-white/45 text-sm">…</div>
      ) : teams.length === 0 ? (
        <div className="flex-1 flex items-center justify-center text-white/40 text-sm px-6 text-center">
          {query ? t('dreamTeam.explore.notFound') : t('dreamTeam.explore.empty')}
        </div>
      ) : (
        <div className="dream-explore-grid">
          {teams.map((team, i) => (
            <button
              key={team.id}
              type="button"
              className={`dream-explore-tile ${i % 7 === 0 ? 'is-tall' : ''}`}
              onClick={() => navigate(`/football/dream-teams/${team.id}`)}
              aria-label={team.name}
            >
              <DreamTeamPitch
                formation={team.formation}
                players={team.players || []}
                boardText={team.formation}
              />
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
